export const RESOURCES = {
  ALL: "all_resources",
  SPECIFIC: "specific_resources" as const,
  DEFAULT_OPTIONS: { resources: [], fields: {} },
  INITIAL_VALUE: { filters: [{}], includeExclude: "Include" }
}
